import axios from "axios";
import { useNavigate } from "react-router-dom"; // note: we cannot directly use hooks here!

console.log("API URL:", process.env.REACT_APP_API_URL);
console.log("Razorpay Key ID:", process.env.REACT_APP_RAZORPAY_KEY_ID);

// Create Axios instance
const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`,
  timeout: 300000, // 5 minutes for general requests
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: true,
});

export const API_HOST_URL = process.env.REACT_APP_API_URL;
export const RAZORPAY_KEY_ID = process.env.REACT_APP_RAZORPAY_KEY_ID;

// Request interceptor for JWT & CSRF
api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("JWT_TOKEN");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    let csrfToken = localStorage.getItem("CSRF_TOKEN");
    if (!csrfToken) {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/csrf-token`,
          { withCredentials: true }
        );
        csrfToken = response.data.token;
        localStorage.setItem("CSRF_TOKEN", csrfToken);
      } catch (error) {
        console.error("Failed to fetch CSRF token", error);
      }
    }

    if (csrfToken) {
      config.headers["X-XSRF-TOKEN"] = csrfToken;
    }
    console.log("X-XSRF-TOKEN " + csrfToken);
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for handling 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.warn("Unauthorized! Redirecting to login...");

      // Remove JWT
      localStorage.removeItem("JWT_TOKEN");
      localStorage.removeItem("CSRF_TOKEN");

      // Redirect using window
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
